import React, {useRef, useState, useEffect} from 'react';
import "./style.scss"
import money from '../../../img/for_table/money.svg';

const ModalContent = ({content, closeModal, ...props}) => {
const blockWidth = useRef(null);
const [customHeight, setCustomHeight] = useState(300)
useEffect(() => {
	setCustomHeight(blockWidth.current.offsetWidth);
}, [blockWidth])

	return (
		<div className='modal-content'>
			<div ref={blockWidth} className='header' style={{background: !!content.image && `url(${content.image})`,
				height: `${customHeight}px`}}>
				<div className='modal-navigation'>
					<p onClick={() => closeModal(false)}>X</p>
				</div>
				<div className="shadow-modal-content">
					<div className='shadow_modal_block'/>
					<p className='gift-title' onClick={ () => console.log(blockWidth.current.offsetWidth)}>
					{content && content.text}
				</p>
				</div>
			</div>
			<div className='coast'>
				<span className='decoration'>---</span>
				{content.price ? (
				<span className="slider_item_price">
            <img src={money} alt="" />
            <p>{content.price}</p>
          </span>
				) : (
					<span className="slider_item_price plase_count">
            <p>{content.places} место</p>
          </span>
				)}
				<span className='decoration'>---</span>
			</div>
			<div className='description' style={{fontSize: props.width < 360 && "16px"}} dangerouslySetInnerHTML={{
				__html: (content && content.description) || ''
			}}/>
		</div>
	);
};

export default ModalContent;
